import React from "react";

const BurgerIcon = ({ ...props }) => (
<svg {...props} width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clipPath="url(#clip0_1161_4889)">
<path d="M19.8846 0.5H1.26923C0.568254 0.5 0 1.06825 0 1.76923C0 2.47021 0.568254 3.03846 1.26923 3.03846H19.8846C20.5856 3.03846 21.1538 2.47021 21.1538 1.76923C21.1538 1.06825 20.5856 0.5 19.8846 0.5Z" fill="white"/>
<path d="M19.8846 14.0386H1.26923C0.568254 14.0386 0 14.6068 0 15.3078C0 16.0088 0.568254 16.577 1.26923 16.577H19.8846C20.5856 16.577 21.1538 16.0088 21.1538 15.3078C21.1538 14.6068 20.5856 14.0386 19.8846 14.0386Z" fill="white"/>
<path d="M10.5769 7.26929H1.26923C0.568254 7.26929 0 7.83754 0 8.53852C0 9.23949 0.568254 9.80775 1.26923 9.80775H10.5769C11.2779 9.80775 11.8462 9.23949 11.8462 8.53852C11.8462 7.83754 11.2779 7.26929 10.5769 7.26929Z" fill="#11FF64"/>
<path d="M10.5769 19.9614H1.26923C0.568254 19.9614 0 20.5297 0 21.2307C0 21.9316 0.568254 22.4999 1.26923 22.4999H10.5769C11.2779 22.4999 11.8462 21.9316 11.8462 21.2307C11.8462 20.5297 11.2779 19.9614 10.5769 19.9614Z" fill="#11FF64"/>
</g>
<defs>
<clipPath id="clip0_1161_4889">
<rect width="21.1538" height="22" fill="white" transform="translate(0 0.5)"/>
</clipPath>
</defs>
</svg>
);

export default BurgerIcon;